import { render, staticRenderFns } from "./SalesEdit.vue?vue&type=template&id=63640f5b&scoped=true&lang=html&"
import script from "./SalesEdit.vue?vue&type=script&lang=js&"
export * from "./SalesEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalesEdit.vue?vue&type=style&index=0&id=63640f5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63640f5b",
  null
  
)

export default component.exports